import { Box, Img, Stack } from "@chakra-ui/react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useEffect, useState } from "react";
const imgData = [
  {
    src: "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_568/t_high_res_template/images/growth/luminosity/1671204380486-358d8b.jpeg",
  },
  {
    src: "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_568/t_high_res_template/images/growth/luminosity/1671204418140-bf6c48.jpeg",
  },
  {
    src: "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_568/t_high_res_template/images/growth/luminosity/1671204615350-d43609.jpeg",
  },
  {
    src: "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_568/t_high_res_template/images/growth/luminosity/1671204399632-702896.jpeg",
  },
  {
    src: "https://res.cloudinary.com/urbanclap/image/upload/q_auto,f_auto,fl_progressive:steep,w_568/t_high_res_template/images/growth/luminosity/1671204414074-1ecbc8.jpeg",
  },
];
export const Fslider = () => {
  const [state] = useState(false);
  useEffect(() => {}, [state]);
  var settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2200,
    pauseOnHover: true,
  };
  return (
    <Stack bg={"white"} justifyContent={"center"} height={"200"} width={"100%"}>
      <Stack margin={"auto"} width={"70%"} justifyContent={"center"}>
        <Slider {...settings}>
          {imgData.map((el, i) => {
            return (
              <Box p={"10"} justifyContent={"center"}>
                <Img src={el.src} alt={`img`} />
              </Box>
            );
          })}
        </Slider>
      </Stack>
    </Stack>
  );
};
